import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

import { buttonWidthUnitless, defaultBorderRadius, defaultMargin, defaultRoundedBorderRadius, defaultTextPadding, maxTextWidth, maxTextWidthUnitless, tagHeight, textFontSize, textMarginLeft, textPaddingRight } from '../../../constants';
export var roundedBorderStyles = {
  borderRadius: "".concat(defaultRoundedBorderRadius)
};
export var beforeElementStyles = function beforeElementStyles(_ref) {
  var textColor = _ref.textColor;
  return {
    position: 'absolute',
    left: 0,
    borderRadius: "".concat(defaultBorderRadius),
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    color: textColor
  };
};
export var chromeStyles = function chromeStyles(_ref2) {
  var activeBackgroundColor = _ref2.activeBackgroundColor,
      backgroundColor = _ref2.backgroundColor,
      backgroundColorHover = _ref2.backgroundColorHover,
      textColor = _ref2.textColor,
      textColorHover = _ref2.textColorHover;
  return {
    backgroundColor: backgroundColor,
    color: textColor,
    pointerEvents: 'none',
    '&:hover': {
      backgroundColor: backgroundColorHover,
      color: textColorHover
    },
    '&:active': {
      backgroundColor: activeBackgroundColor,
      color: textColorHover
    },
    '& button:hover': {
      color: textColor
    },
    '&>span:hover': {
      color: textColor
    },
    borderRadius: "".concat(defaultBorderRadius),
    cursor: 'default',
    display: 'inline-flex',
    position: 'relative',
    height: "".concat(tagHeight),
    lineHeight: 1,
    margin: "".concat(defaultMargin),
    padding: 0,
    overflow: 'hidden'
  };
};
export var chromeLinkStyles = function chromeLinkStyles(_ref3) {
  var activeBackgroundColor = _ref3.activeBackgroundColor,
      activeBackgroundColorRemoval = _ref3.activeBackgroundColorRemoval,
      hoverBackgroundColor = _ref3.hoverBackgroundColor,
      hoverTextColor = _ref3.hoverTextColor,
      hoverBackgroundColorRemoval = _ref3.hoverBackgroundColorRemoval,
      focusRingColor = _ref3.focusRingColor;
  return {
    '&:hover': {
      backgroundColor: hoverBackgroundColor,
      color: hoverTextColor
    },
    '&:active': {
      backgroundColor: activeBackgroundColor,
      color: hoverTextColor
    },
    '&:focus-within': {
      boxShadow: "0 0 0 2px ".concat(focusRingColor),
      outline: 'none'
    },
    '&[data-removing="true"]:focus-within': {
      boxShadow: "0 0 0 2px transparent",
      outline: 'none'
    },
    '&[data-ishoverclosebutton="true"]': {
      backgroundColor: hoverBackgroundColorRemoval
    },
    '&[data-isHoverCloseButton="true"]:active': {
      backgroundColor: activeBackgroundColorRemoval
    }
  };
};
export var hasAfterStyles = {
  paddingRight: "".concat(textPaddingRight),
  maxWidth: "".concat(maxTextWidthUnitless - buttonWidthUnitless, "px")
};
export var hasBeforeStyles = {
  marginLeft: "".concat(textMarginLeft)
};
export var textStyles = {
  fontSize: textFontSize,
  fontWeight: 'normal',
  lineHeight: 1,
  paddingLeft: defaultTextPadding,
  paddingRight: defaultTextPadding,
  paddingTop: '2px',
  paddingBottom: '2px',
  borderRadius: defaultBorderRadius,
  maxWidth: maxTextWidth,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
};
export var linkStyles = function linkStyles(linkHoverColor) {
  return _objectSpread(_objectSpread({}, textStyles), {}, {
    pointerEvents: 'auto',
    ':not([data-color="standard"])': {
      color: 'inherit',
      textDecoration: 'underline'
    },
    textDecoration: 'none',
    '&:hover': {
      color: linkHoverColor
    },
    '&:focus': {
      outline: 'none'
    }
  });
};